"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
var firebase = require("firebase");
require("firebase/firestore");

exports.default = function (firebaseConfig) {

	// initializeApp
	var app = firebase.initializeApp(firebaseConfig)['firebase_'];

	return {
		auth: app.auth(),
		firebase: app.database(),
		firestore: app.firestore()
	};
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-mastermind/lib/configureFirebase.js
// module id = 959
// module chunks = 0